import * as React from 'react';
import { Button, Image, UIHeading2 } from '@cian/ui-kit';

import { RAISING_HANDS } from '../../../../constants/images';

import styles from './styles.css';

interface ISuccessMessage {
  onClose: () => void;
  message: string;
}
export const SuccessMessage: React.FC<ISuccessMessage> = ({ onClose, message }) => {
  return (
    <div className={styles['success-message']}>
      <Image src={RAISING_HANDS} width={80} height={70} />
      <div className={styles['title']}>
        <UIHeading2>{message}</UIHeading2>
      </div>
      <div className={styles['control']}>
        <Button onClick={onClose} size="L">
          Спасибо
        </Button>
      </div>
    </div>
  );
};
